import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./App.css";
import "flag-icons/css/flag-icons.min.css";
import App from "./App.tsx";
import { AuthProvider } from "./context/AuthContext.tsx";
import { SnackbarProvider } from "notistack";
import { CurrencyProvider } from "./context/Currency.tsx";
import { VideoProvider } from "./context/VideoContext.tsx";
import * as Sentry from "@sentry/react";
import "./safe-remove-child";
import "./google-translate-cleaner";
import config from "./config/environment.ts";
import { TutorialProvider } from "./context/TutorialContext.tsx";

Sentry.init({
  dsn: config.sentryDns,
  enabled: config.environment === "production",

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],

  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  sendDefaultPii: true,


  beforeSend(event, hint) {
    const exception = hint.originalException as any;

    if (exception?.response?.data?.trigger) {
      return null;
    }

    const msg = event?.exception?.values?.[0]?.value || "";
    const ignoreList = [
      "ResizeObserver",
      "Non-Error promise rejection",
      "ChunkLoadError",
      "Loading chunk",
    ];

    if (ignoreList.some((i) => msg.includes(i))) {
      return null;
    }

    if (exception?.response) {
      event.tags = {
        ...event.tags,
        http_status: exception.response.status,
      };

      event.contexts = {
        ...event.contexts,
        response: {
          status: exception.response.status,
          statusText: exception.response.statusText,
          url: exception.config?.url || window.location.href,
          data: exception.response.data,
        },
      };
    }
    return event;
  },
});

createRoot(document.getElementById("root")!).render(
  <SnackbarProvider
    maxSnack={3}
    anchorOrigin={{ vertical: "top", horizontal: "right" }}
  >
    <StrictMode>
      <CurrencyProvider>
        <AuthProvider>
          <VideoProvider>
            <TutorialProvider>
              <App />
            </TutorialProvider>
          </VideoProvider>
          </AuthProvider>
        </CurrencyProvider>
      </StrictMode>
    </SnackbarProvider>
);
